import { gql } from "@apollo/client";

export const IMPORT_CLIENT_HUB_ZONE_CONFIG = gql`
    mutation ImportClientHubZoneConfig($input: ImportClientHubZoneConfigInput!) {
        importClientHubZoneConfig(input: $input) {
            taskNo
            totalCount
        }
    }
`;

export interface ImportClientHubZoneConfigInput {
    objectKey: string;
    filename: string;
    channelId: number;
    hubId: number;
    activeTime: number;
}

export interface ImportClientHubZoneConfigResponse {
    importClientHubZoneConfig: {
        taskNo: string;
        totalCount: number;
    };
}

export interface ImportClientHubZoneConfigVariables {
    input: ImportClientHubZoneConfigInput;
}

